<template>
  <VueQrcode id="qr-code-download" class="hidden" :value="link" tag="img" :options="{ margin: 24, width: 800 }" />
</template>

<script lang="ts" setup>
import VueQrcode from '@chenfengyuan/vue-qrcode'

interface Props {
  link: string
}

const { link } = defineProps<Props>()
</script>
